import { ContentType, HttpClient, RequestParams } from '../http-client';

export class CompanyCrew<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;
  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * Create company account function
   * @param data { "full_name": string, "email": string, "phone_number": string}
   * @param params null
   * @returns customer account object
   */
  inviteCompanyCrew = (data: any, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/crew`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  getCompanyCrew = (
    query: {
      page: number;
      full_name?: string;
      rank?: string;
      vessel_type?: string;
      crew_group?: string;
      status?: string;
      employee_id?: string;
    },
    params: RequestParams = {}
  ) =>
    this.http.request<any>({
      path: `/api/v2/company/crew`,
      method: 'GET',
      secure: true,
      ...(query && { query }),
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  getCompanyCrewDetailById = (id: string, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/crew/detail/${id}`,
      method: 'GET',
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  getCompanyCrewById = (id: string, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/crew/${id}`,
      method: 'GET',
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  updateCompanyCrewById = (id: number, data: any, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/crew/${id}`,
      method: 'PATCH',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  deleteCompanyCrewById = (id: string, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/crew/${id}`,
      method: 'DELETE',
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  downloadCompanyCrewById = (id: string, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/crew/download/${id}`,
      method: 'GET',
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  updateCompanyCrewGroup = (data: any, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/crew/group`,
      method: 'PATCH',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  getCompanyCrewDocuments = (
    query?: {
      page?: number | string;
      search?: string;
      document_type?: (
        | 'certificate'
        | 'visa'
        | 'vaccination'
        | 'seaman_book'
        | 'id_card'
        | 'passport'
      )[];
      vessel_id?: number[];
      rank?: string[];
      status?: ('expired' | 'expiring_soon' | 'valid')[];
      is_archived?: boolean;
    },
    params: RequestParams = {}
  ) =>
    this.http.request<any>({
      path: `/api/v2/company/crew/documents`,
      method: 'GET',
      secure: true,
      ...(query && { query }),
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  getCompanyCrewDocumentSummary = (params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/crew/documents/summary`,
      method: 'GET',
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  patchArchiveCrewDocument = (data: any, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/crew/documents/archiver`,
      method: 'PATCH',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  postCompanyCrewCertificate = (data: any, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/crew/document/certificate`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  updateCompanyCrewCertificate = (
    id: string,
    data: any,
    params: RequestParams = {}
  ) =>
    this.http.request<any>({
      path: `/api/v2/company/crew/document/certificate/${id}`,
      method: 'PATCH',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  postCompanyCrewIdCard = (data: any, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/crew/document/id-card`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  updateCompanyCrewIdCard = (
    id: string,
    data: any,
    params: RequestParams = {}
  ) =>
    this.http.request<any>({
      path: `/api/v2/company/crew/document/id-card/${id}`,
      method: 'PATCH',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  postCompanyCrewMcu = (data: any, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/crew/document/mcu`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  updateCompanyCrewMcu = (id: string, data: any, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/crew/document/mcu/${id}`,
      method: 'PATCH',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  postCompanyCrewPassport = (data: any, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/crew/document/passport`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  updateCompanyCrewPassport = (
    id: string,
    data: any,
    params: RequestParams = {}
  ) =>
    this.http.request<any>({
      path: `/api/v2/company/crew/document/passport/${id}`,
      method: 'PATCH',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  postCompanyCrewSeamanBook = (data: any, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/crew/document/seaman-book`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  updateCompanyCrewSeamanBook = (
    id: string,
    data: any,
    params: RequestParams = {}
  ) =>
    this.http.request<any>({
      path: `/api/v2/company/crew/document/seaman-book/${id}`,
      method: 'PATCH',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  postCompanyCrewVaccine = (data: any, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/crew/document/vaccine`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  updateCompanyCrewVaccine = (
    id: string,
    data: any,
    params: RequestParams = {}
  ) =>
    this.http.request<any>({
      path: `/api/v2/company/crew/document/vaccine/${id}`,
      method: 'PATCH',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  postCompanyCrewVisa = (data: any, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/crew/document/visa`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  updateCompanyCrewVisa = (id: string, data: any, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/crew/document/visa/${id}`,
      method: 'PATCH',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  postCompanyCrewVaccination = (data: any, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/crew/document/vaccine`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  updateCompanyCrewVaccination = (
    id: string,
    data: any,
    params: RequestParams = {}
  ) =>
    this.http.request<any>({
      path: `/api/v2/company/crew/document/vaccine/${id}`,
      method: 'PATCH',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  postCompanyCrewExperience = (data: any, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/crew/experiences`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  updateCompanyCrewExperience = (
    id: string,
    data: any,
    params: RequestParams = {}
  ) =>
    this.http.request<any>({
      path: `/api/v2/company/crew/experiences/${id}`,
      method: 'PATCH',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  deleteCompanyCrewExperience = (id: string, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/crew/experiences/${id}`,
      method: 'DELETE',
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  uploadCompanyCrewFile = (data: any, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/crew/document/file`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.FormData,
      ...params,
    });

  getDocumentReplacementSchema = (
    query: { document_type: string },
    params: RequestParams = {}
  ) =>
    this.http.request<any>({
      path: `/api/v2/company/crew/document/replacement`,
      method: 'GET',
      ...(query && { query }),
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  getPresignedPayload = (
    data: { file_name: string; content_type: string },
    params: RequestParams = {}
  ) =>
    this.http.request<any>({
      path: `/api/v2/company/upload/document/presigned`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  patchReplaceCrewDocument = (
    data: {
      document_type: string;
      reference_id: string;
      data: any;
    },
    params: RequestParams = {}
  ) =>
    this.http.request<any>({
      path: `/api/v2/company/crew/documents/replacement`,
      method: 'PATCH',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  getCompanyCrewApplicant = (
    query: {
      page: number;
      full_name?: string;
      rank?: string;
      vessel_type?: string;
      crew_group?: string;
      status?: string;
    },
    params: RequestParams = {}
  ) =>
    this.http.request<any>({
      path: `/api/v2/company/crew/applicants`,
      method: 'GET',
      secure: true,
      ...(query && { query }),
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  getCompanyCrewScheduleById = (id: string, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/crew/database/${id}/schedules`,
      method: 'GET',
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  getCompanyVesselScheduleRelation = (
    query: {
      cd_id: string;
      request: string;
      vessel_id?: string;
    },
    params: RequestParams = {}
  ) =>
    this.http.request<any>({
      path: `/api/v2/company/crew/database/related`,
      method: 'GET',
      ...(query && { query }),
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  getCompanyCrewDatabaseParams = (params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/crew/databases/params`,
      method: 'GET',
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  getCompanyCrewPhone = (
    query: {
      phone: string;
      method?: string;
    },
    params: RequestParams = {}
  ) =>
    this.http.request<any>({
      path: `/api/v2/company/crew/phone`,
      method: 'GET',
      ...(query && { query }),
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  getCompanyCrewLms = (id: string | number, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/company/crew/${id}/lms`,
      method: 'GET',
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
